module.exports = __webpack_public_path__ + "img/icon-plus.2f7e47d1.svg";